import classNames from 'classnames'
import React from 'react'
import ReactTooltip from 'react-tooltip'
import { v4 } from 'uuid'

type Props = {
    place: "top" | "right" | "left"
    children: (ttId: string) => void
    disabled?: boolean
    centerText?: boolean
    fullWidth?: boolean

    disable?: boolean
}

export const WithTooltip: React.FC<Props> = ({ fullWidth = false, ...props }) => {
    const ttId = v4()

    if (props.disable) {
        return (
            <>
                {props.children}
            </>
        )
    }

    return (
        <>
            <ReactTooltip
                disable={props.disabled}
                place={props.place}
                type="dark"
                effect="solid"
                className={classNames(
                    "tt-small-monospace",
                    { 'tt-full-width': fullWidth },
                    { "text-center": props.centerText }
                )}

                id={ttId}
            />

            {props.children(ttId)}
        </>
    )
}
